import React from "react";
import { ArrowRightLeft } from "lucide-react";

// A mesa deste celular mudou (quem abriu mudou, ou o garçom transferiu) e ele
// veio junto. Aviso com um toque para fechar: toast some sozinho e a pessoa
// ficaria sem entender por que o nome da mesa trocou.
export default function AvisoMesaMudou({ texto, mesa, darkMode, onFechar }) {
  if (!texto) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-black/50 p-4" data-e2e="mesa-aviso-mudou">
      <div className={`w-full max-w-sm rounded-3xl p-6 text-center shadow-2xl ${darkMode ? "bg-zinc-900 text-zinc-100" : "bg-white text-zinc-900"}`}>
        <div className="w-14 h-14 mx-auto rounded-full bg-primary/10 text-primary flex items-center justify-center mb-3">
          <ArrowRightLeft className="w-7 h-7" />
        </div>
        <p className="text-xs uppercase tracking-widest opacity-60">Agora você está na</p>
        <h2 className="text-3xl font-black mt-1 mb-2">{String(mesa?.nome || `Mesa ${mesa?.numero ?? ""}`).toUpperCase()}</h2>
        <p className="text-sm opacity-70 mb-5" data-e2e="mesa-aviso-texto">
          {texto} Seus pedidos continuam na mesma conta.
        </p>
        <button
          type="button"
          onClick={onFechar}
          data-e2e="mesa-aviso-ok"
          className="w-full h-14 rounded-full bg-primary text-primary-foreground text-base font-black active:scale-[0.98] transition"
        >
          ENTENDI
        </button>
      </div>
    </div>
  );
}
